import { createContext, useContext } from 'react';

export const AuthContext = createContext({
  state: {},
  dispatch: () => {},
});

export const useAuthContext = () => useContext(AuthContext);
